// extracted by mini-css-extract-plugin
export default {"root":"JnIAq3t0CFOmIIzGC5ca","row":"rOUhaUR8tvV83ARVeVbT X_gKw8iu5ccD29QeTAez","dial-title":"s2YNiZlLlm0inyYGl9Qi","dialTitle":"s2YNiZlLlm0inyYGl9Qi"};